var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('e-dialog',{attrs:{"dialogTitle":"易派客提醒您","centerDialogVisible":_vm.selectOnlyVisible,"popupWidth":'420px'},on:{"resetPopupData":_vm.resetPopupData,"submitPopupData":_vm.resetPopupData}},[_c('div',[_vm._v("只能选择一家评价机构进行相应的操作")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }